import type { WriteOp } from "../components/WriteOpsHint";

export const ORGS_WRITE_OPS: WriteOp[] = [
  {
    channel: "HTTP",
    label: "Organization anlegen",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/organizations \\\n  -d \'{"id": "acme", "display_name": "Acme Corp"}\'',
  },
  {
    channel: "HTTP",
    label: "Org-Admin hinzufügen",
    snippet:
      'curl -X POST -H "Authorization: Bearer $KW_TOKEN" -H "Content-Type: application/json" \\\n  http://kontextwerk.localhost:8080/core/v1/admin/organizations/<org_id>/admins \\\n  -d \'{"subject": "user@example.com"}\'',
  },
];
